<template>
  <div class="app-container">
    <navigation :title="headerTitle"></navigation>
    <div class="message">
      <div class="prompt-title-detail shserif">
        <div>{{ lecture.title }}</div>
        <div class="prompt-title-right" v-if="lecture.subTitle">{{ lecture.subTitle }}</div>
      </div>
      <div class="prompt-time shserif-regular" v-if='(lecture.startTime || "").split(" ")[0]===(lecture.endTime || "").split(" ")[0]' >
        <svg-icon iconClass='time' className='pre-icon'></svg-icon>
        {{lecture.startTime.split(' ').join(' '+lecture.startWeek+' ')}}-{{(lecture.endTime || "").split(' ')[1]}}
      </div>
      <div class="prompt-time shserif-regular" v-else-if="lecture.endTime" >
        <svg-icon iconClass='time' className='pre-icon'></svg-icon>
        {{ lecture.startTime.split(' ').join(' '+lecture.startWeek+' ') }}—{{ lecture.endTime.split(' ').join(' '+lecture.endWeek+' ') }}
      </div>
      <div class="prompt-time shserif-regular" v-else-if="headerTitle==='展览详情' || headerTitle==='培训详情'">
        <svg-icon iconClass='time' className='pre-icon'></svg-icon>
        {{ lecture.startTime+' '+lecture.startWeek }} 起
      </div>
      <div class="prompt-time shserif-regular" v-else>
        <svg-icon iconClass='time' className='pre-icon'></svg-icon>
        {{ lecture.startTime.split(' ').join(' '+lecture.startWeek+' ') }}
      </div>
      <div class="prompt-address shserif-medium">
        <svg-icon iconClass='address' className='pre-icon'></svg-icon>
        {{ lecture.placeRegion?lecture.placeRegion:'' }}
        <span v-html="lecture.place"></span>
      </div>
    </div>
    <div class="content">
      <div class="host" v-if="lecture.hostIds">
        <van-cell title="主讲人" is-link center class="shserif-semibold">
          <template #right-icon>
<!--            <div>-->
<!--              <span class="more-val shserif-regular">更多</span>-->
<!--            </div>-->
          </template>
        </van-cell>
        <div class="hosts" v-for="(item,index) in lecture.hosts">
          <van-cell v-if="lecture.hosts" :title="item.name" class="font-34 shserif-medium  host-cell" :style="{height: item.divHeight}">
            <template #icon>
              <img v-if="item.coverPath" :src="item.coverPath" alt="" class="list-img">
            </template>
            <template #label>
              <div class="hosts-introduce shserif-light">{{ item.introduce }}</div>
            </template>
          </van-cell>
          <div v-if="item.isShow">
            <div class="unfold" v-if="item.isUnfold" @click="showCalendar(item)">点击展开<van-icon name="arrow-down" /></div>
            <div class="unfold" v-else @click="hideCalendar(item)">点击收回<van-icon name="arrow-up" /></div>
          </div>
        </div>
      </div>
      <h1 class="font-32 shserif-medium" v-if="lecture.introduce">{{ introduce }}：</h1>
      <div class="introduce shserif-extralight" v-html="lecture.introduce"></div>
      <div class="collect-share">
        <div class="collect">
          <collect v-if="lecture" :resource="resource"></collect>
        </div>
      </div>
      <page-share :show="showShare" @show='getShow' :title="resource.module"></page-share>
    </div>
    <version></version>
  </div>
</template>

<script>
import Vue from 'vue'
import { Cell, CellGroup, List, Icon, Checkbox } from 'vant'
import {request} from '../../untils/request'
import navigation from '../../components/navigation'
import version from '../../components/version'
import pageShare from '../../components/pageShare'
import collect from '../../components/collect'
import {parseTime} from '../../untils/formatTime'

Vue.use(Cell).use(CellGroup).use(List).use(Icon).use(Checkbox)
export default {
  name: 'exhibitionDetail',
  components: {navigation, version, pageShare,collect},
  data () {
    return {
      baseUrl: process.env.API_ROOT,
      lecture: '',
      headerTitle: '',
      introduce: '',
      showShare: false,
      resource:{
        title: '',
        module: '',
        resourceId:this.$route.query.id
      },
      phone:[],
    }
  },
  created () {
    this.getMessage()
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    getMessage () {
      var id = this.$route.query.id
      request('get', '/nlc-web/api/nlcNotice', {}, id).then(res => {
        console.log('讲座详情', res)
        if(res.data.noticeType === "NOTICE_LECTURE"){
          this.resource.module = '讲座预告'
          this.headerTitle = '讲座详情'
          this.introduce = '讲座介绍'
          res.data.startTime = parseTime(res.data.startTime,'{y}-{m}-{d} {h}:{i}')
          res.data.endTime = parseTime(res.data.endTime,'{y}-{m}-{d} {h}:{i}')
        } else if (res.data.noticeType === "NOTICE_EXHIBITION") {
          this.resource.module = '展览预告'
          this.headerTitle = '展览详情'
          this.introduce = '展览简介'
          res.data.startTime = parseTime(res.data.startTime,'{y}-{m}-{d}')
          res.data.endTime = parseTime(res.data.endTime,'{y}-{m}-{d}')
        } else if (res.data.noticeType === "NOTICE_SHOW") {
          this.resource.module = '演出预告'
          this.headerTitle = '演出详情'
          this.introduce = '演出简介'
          res.data.startTime = parseTime(res.data.startTime,'{y}-{m}-{d} {h}:{i}')
          res.data.endTime = parseTime(res.data.endTime,'{y}-{m}-{d} {h}:{i}')
        } else {
          this.resource.module = '培训预告'
          this.headerTitle = '培训详情'
          this.introduce = '培训简介'
          res.data.startTime = parseTime(res.data.startTime,'{y}-{m}-{d}')
          res.data.endTime = parseTime(res.data.endTime,'{y}-{m}-{d}')
        }
        if(res.data.place){
          res.data.place = res.data.place.replace(/(0[0-9]{2,3}-[0-9]{7,8}|[0-9]{7,8})/g,function(str1){
            return '<a href=\'tel:'+str1+'\' class="lecture-tel">'+str1+'</a>'
          })
        }
        this.lecture = res.data
        this.lecture.hosts.forEach(item=>{
          console.log('item.introduce.length',item.introduce.length)
          if(item.introduce.length<68){
            item.isShow = false
          } else {
            item.isShow = true
            item.isUnfold = true
            item.divHeight = '2rem'
          }
        })
        this.resource.title = res.data.title
      })
    },
    share () {
      this.showShare = true
    },
    getShow (msg) {
      this.showShare = msg
    },
    // 分割多个电话
    getCaption(obj,state) {
      let index=obj.lastIndexOf("、");
      if(state==0){
        obj=obj.substring(0,index);
      }else {
        obj=obj.substring(index+1,obj.length);
      }
      return obj;
    },
    // 展开
    showCalendar (e) {
      e.isUnfold = false
      e.divHeight = `auto`
      this.$forceUpdate()
    },
    //收起
    hideCalendar(e) {
      e.isUnfold = true
      e.divHeight = `${2}rem`
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
.app-container{
  background:#ecf5fd;
  overflow-y:scroll;
  min-height:100%;
}

.shserif,.shserif-regular{
  font-family: SourceHanSerifCN-Regular;
}
.shserif-medium{
  font-family: SourceHanSerifCN-Medium;
}
.shserif-semibold{
  color: #444649;
  font-size:.32rem;
  font-weight:bold;
  font-family: SourceHanSerifCN-SemiBold;
}
.shserif-light{
  font-family: SourceHanSerifCN-Light;
}
.shserif-extralight{
  font-family: SourceHanSerifCN-Regular;
}
.font-51{
  font-size: .51rem;
}
.font-34{
  font-size: .3rem;
}
.font-32{
  font-size: .32rem;
}
.font-24{
  font-size: .24rem;
}
.message{
  width:6.25rem;
  margin:1.18rem .28rem .16rem .28rem;
  padding:.37rem .34rem .38rem .34rem;
  background:url("../../assets/img/lecture-bg.png") no-repeat;
  background-size:100% 100%;
  font-size:.28rem;
  color:#47494c;
}
.prompt-title-detail{
  font-size:.36rem;
  word-wrap:break-word;
}

.more-val{
  width:.66rem;
  display:inline-block;
  font-size:.24rem;
  font-family: SourceHanSansCN-Regular;
  line-height: .24rem;
  vertical-align: middle;
}

.svg-icon{
  margin-right: .18rem;
}
.prompt-time{
  margin-top:.2rem;
}
.prompt-address{
  margin-top:.21rem;
}
.content{
  width: 6.94rem;
  margin:.3rem .28rem .16rem .28rem;
  border-radius:8px;
  background:#fff;
  padding:.1rem 0;
}
.van-cell--clickable::after{
  border:0 !important;
}
.van-cell::after{
  border-width: 0;
}
.list-img{
  height:1.73rem;
  margin-right:.26rem;
  box-shadow: 6px 4px 10px -6px #000;
  vertical-align: middle;
  line-height: 1.73rem;
  margin-top: .1rem;
}
h1{
  font-size:.32rem;
  color:#444649;
  margin-left:.35rem;
}
.introduce{
  font-size:.3rem;
  color:#444649;
  padding:0 .35rem .25rem .35rem;
  text-align: justify;
}
.share{
  color:#444649;
  font-size:.24rem;
  margin-left:.22rem;
  line-height: .57rem;
}
.hosts-introduce{
  line-height:.36rem;
  font-size:.28rem;
}
.hosts{
  margin-bottom:.15rem;
}
.collect-share{
  display:flex;
}
>>>p{
  margin:0;
  padding:0;
  line-height:.4rem !important;
}
.lecture-tel{
  margin-left:.2rem;
}
.unfold{
  width:100%;
  text-align:center;
  color:#94979C;
  font-size:.2rem;
  background:#fff;
  border-radius:8px;
  padding-top:.15rem;
}
.prompt-title-right{
  text-align:right;
}
.host-cell{
  padding:0 .32rem;
}
</style>



// WEBPACK FOOTER //
// src/view/exhibitionDetail/index.vue